"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBasicParameters = exports.FormikWrapper = void 0;
var formik_1 = require("formik");
var _ = require("lodash");
var React = require("react");
var TextWithRequired_1 = require("../Form/TextWithRequired");
var Label_1 = require("../Inputs/Label");
var Theme_1 = require("../Theme");
var FormikWrapper_styles_1 = require("./FormikWrapper.styles");
var buildLabel = function (wrapperProps) {
    return React.createElement(Label_1.Label, { For: wrapperProps.Name },
        React.createElement(TextWithRequired_1.TextWithRequired, { LabelText: wrapperProps.Label, ShowRequiredIndicator: !wrapperProps.Disabled && wrapperProps.ShowRequired }));
};
var buildControl = function (_a, props) {
    var Name = _a.Name, FormikProps = _a.FormikProps, RenderControl = _a.RenderControl, ShowRequired = _a.ShowRequired;
    return RenderControl(Name, props, (ShowRequired && FormikProps.errors[Name] !== undefined && FormikProps.touched[Name] === true));
};
var buildDescribedBy = function (props) {
    var describedBy = props.Name + "_describedby";
    return React.createElement(FormikWrapper_styles_1.MessageWrapper, { id: describedBy },
        (props.FormikProps && props.FormikProps.errors && _.get(props.FormikProps.errors, props.Name))
            && (props.FormikProps && props.FormikProps.touched && _.get(props.FormikProps.touched, props.Name))
            && React.createElement(FormikWrapper_styles_1.ErrorText, { "aria-live": "assertive", role: "alert" }, _.get(props.FormikProps.errors, props.Name)),
        !(props.FormikProps && props.FormikProps.errors
            && _.get(props.FormikProps.errors, props.Name)
            && props.FormikProps && props.FormikProps.touched && _.get(props.FormikProps.touched, props.Name))
            && React.createElement(FormikWrapper_styles_1.HelpText, null, props.HelperText));
};
var FormikWrapper = /** @class */ (function (_super) {
    __extends(FormikWrapper, _super);
    function FormikWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormikWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(formik_1.Field, { name: this.props.Name, render: function (props) { return (_this.props.Layout === "ControlAboveLabel" ?
                // Builds a layout of control over label (preferred)
                React.createElement(FormikWrapper_styles_1.FieldContainer, null,
                    buildLabel(_this.props),
                    buildControl(_this.props, props),
                    buildDescribedBy(_this.props))
                :
                    // Builds a layout of control then label for use with check-boxes
                    React.createElement(FormikWrapper_styles_1.CheckboxFieldContainer, null,
                        React.createElement(FormikWrapper_styles_1.CheckboxDescriptionWrapper, null, buildControl(_this.props, props)),
                        buildLabel(_this.props),
                        buildDescribedBy(_this.props))); } }));
    };
    FormikWrapper.defaultProps = {
        Layout: "ControlAboveLabel",
    };
    return FormikWrapper;
}(React.Component));
exports.FormikWrapper = FormikWrapper;
var AddBasicParameters = function (name, props, hasErrors, disabled, required) {
    return __assign(__assign({}, props.field), { "aria-describedby": name + "_describedby", "aria-invalid": hasErrors, "aria-required": required, "disabled": disabled, "id": name, "style": !disabled && hasErrors ? { borderColor: Theme_1.Color.Red.R60 } : null });
};
exports.AddBasicParameters = AddBasicParameters;
